import React from 'react';
import OfflineBolt from '@material-ui/icons/OfflineBolt';
import { Grid, Hidden } from '@material-ui/core';

import './AutomatedTransferBadge.scss';

const AutomatedTransferBadge = () =>
    <div className="automated-transfer-container">
        <Hidden smDown>
            <div><OfflineBolt htmlColor='#05C3DE' style={{ width: '24px', height: '24px', marginRight: '8px' }} /></div>
        </Hidden>
        <div>
            <Grid container>
                <Grid item xs={11}>
                  <div>
                      <strong>Eligible for Automated Transfer</strong>
                  </div>
                  <div style={{ fontSize: '12px' }}>Fast. Easy. No extra paperwork.</div>
                </Grid>
                <Grid item xs={1}>
                    <Hidden smUp>
                        <OfflineBolt htmlColor='#05C3DE' style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                    </Hidden>
                </Grid>
            </Grid>
        </div>
    </div>;

export default AutomatedTransferBadge;
